import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function CaseStudies() {
  const cases = [{
    industry: 'Banking',
    title: 'Financial Services AI Transformation',
    description: 'Deployed intelligent document processing for a leading East African bank, reducing processing time by 75% and improving accuracy.'
  }, {
    industry: 'Logistics',
    title: 'Supply Chain Optimization',
    description: 'AI-powered demand forecasting for a major logistics company, improving accuracy by 40% and reducing inventory waste.'
  }, {
    industry: 'Telecommunications',
    title: 'Customer Experience Revolution',
    description: 'Conversational AI platform serving 100K+ customers monthly for a telecom provider, reducing support ticket resolution time.'
  }];
  return <section id="case-studies" className="py-24 bg-brand-black relative" data-id="element-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-51">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6" data-id="element-52">
          <div className="max-w-2xl" data-id="element-53">
            <div className="inline-flex items-center gap-2 mb-4" data-id="element-54">
              <div className="w-8 h-1 bg-brand-primary rounded-full" data-id="element-55"></div>
              <h2 className="text-brand-primary font-semibold uppercase tracking-wider text-sm" data-id="element-56">
                Success Stories
              </h2>
            </div>
            <h3 className="text-3xl md:text-5xl font-bold text-white" data-id="element-57">
              Proven Impact Across Industries
            </h3>
          </div>
          <a href="#" className="hidden md:flex items-center gap-2 text-brand-primary hover:text-brand-light font-medium transition-colors group" data-id="element-58">
            View All Cases
            <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-59" />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-60">
          {cases.map((study, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} whileHover={{
          y: -10
        }} className="glass-card rounded-2xl overflow-hidden group hover:border-brand-primary/40 transition-all duration-300 flex flex-col" data-id="element-61">
              {/* Abstract Image Placeholder */}
              <div className="w-full h-48 bg-gradient-to-br from-[#1a1718] via-brand-dark/20 to-brand-primary/20 relative overflow-hidden" data-id="element-62">
                <div className="absolute inset-0 grid-pattern opacity-40" data-id="element-63"></div>
                <div className="absolute inset-0 bg-brand-primary/10 group-hover:bg-brand-primary/0 transition-colors duration-500" data-id="element-64"></div>
                <div className="absolute bottom-4 left-4 bg-brand-primary text-white text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full" data-id="element-65">
                  {study.industry}
                </div>
              </div>

              <div className="p-8 flex flex-col flex-grow" data-id="element-66">
                <h4 className="text-xl font-bold text-white mb-3 group-hover:text-brand-light transition-colors" data-id="element-67">
                  {study.title}
                </h4>
                <p className="text-gray-400 mb-6 flex-grow" data-id="element-68">
                  {study.description}
                </p>
                <a href="#" className="flex items-center gap-2 text-brand-primary font-medium group/link mt-auto" data-id="element-69">
                  Read More
                  <ArrowRightIcon className="w-4 h-4 group-hover/link:translate-x-1 transition-transform" data-id="element-70" />
                </a>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-10 text-center md:hidden" data-id="element-71">
          <a href="#" className="inline-flex items-center gap-2 text-brand-primary hover:text-brand-light font-medium transition-colors group" data-id="element-72">
            View All Cases
            <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-73" />
          </a>
        </div>
      </div>
    </section>;
}